import React from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";

import {
  PureComponent,
  Serialize,
  Description,
  GroupBox
} from "core/components";
import {
  Block,
  Button,
  CardContent,
  List,
  ListInput,
  ListItem,
  Popover
} from "core/components/Framework7";
import { finalize, finalizeOnline, checkPaymentResult } from "content/pages/OrderStep/Module";
import { CartProduct } from "content/components";
import { StepsTab } from "./Components/StepsTab";
import classes from "./styles.module.css";


class Finalize extends PureComponent {
  constructor(props) {
    super(props);

    const view = this.$f7.views.get("#view-cart");
    this.router = view && view.router;

    this.state = {
      value: null,
      isOnlinePayment: false,
      orderDescription: ""
    };
  }

  componentDidMount() {
    const { order } = this.props;
    // console.log("order.billingInfo", order.billingInfo)
    const onlineStatus = order ? order.billingInfo?.typeAlias == "online" ? true : false : null;
    // console.log("before state online", this.state.isOnlinePayment);
    // console.log("onlineStatus", onlineStatus);
    this.setState({
      isOnlinePayment: onlineStatus
    });
    // console.log("after state online", this.state.isOnlinePayment);
  }

  handleNext() {
    const { order } = this.props;

    this.$f7.dialog.preloader("در حال ارسال اطلاعات");

    const id = order.id;
    // const { orderDescription } = this.state;

    const model = {
      description: this.state.orderDescription || ''
    }

    const params = {
      store: 2
    };

    this.props
      .finalize(id, model, params)
      .then(r => {
        this.router && this.router.navigate("/step/complete");
      })
      .catch(err => {
        if (!err) return;
        const msg = err.message;
        if (msg.indexOf("insufficient stock quantity") == 0) {
          return this.$f7.dialog.confirm(
            "تغییری در قیمت و یا موجودی کالاهای شما به وجود آمده، لطفا سبدخرید خود را بازنگری کنید.",
            "خطا",
            () => {
              this.router.navigate("/cart", {
                reloadAll: true,
                props: { reloadCart: true }
              });
            }
          );
        } else {
          return this.$f7.dialog.alert(
            "خطایی در ثبت سفاش شما رخ داده، مجددا تلاش کنید.",
            "خطا"
          );
        }
      })
      .finally(r => {
        this.$f7.dialog.close();
      });
  }

  handleOrderDescription(e) {
    this.setState({
      orderDescription: e.target.value
    }, () => {
      // console.log("order desc", this.state.orderDescription);
    })

  }

  handleNextOnlinePayment() {
    const { order } = this.props;

    this.$f7.dialog.preloader("در حال ارسال اطلاعات");

    const id = order.id;

    const params = {
      store: 2
    };

    const model = {
      description: this.state.orderDescription || ''
    }

    this.props
      .finalizeOnline(id, model, params)
      .then(r => {
        //اسمش باید درست ششود
        const { gateWayUrl, token } = r.paymentGateWay;

        // console.log("log gateWayUrl", gateWayUrl);
        // console.log("log token", token);

        this.checkPaymentStatus(id, 2);


        // const newWindow = window.open('http://stackoverflow.com/');
        // if (newWindow) {
        //   // newWindow.focus();
        // } else {
        //   alert('Please allow popups for this website');
        // }

        //code for redirect user to shaparak
        return (
          <form onload={document.forms['forms'].submit()} action={"https://sep.shaparak.ir/OnlinePG/OnlinePG"} method="post">
            <input type="hidden" name="Token" value={token ?? ""} />
            <input name="GetMethod" type="text" value="" />
          </form>
        )


        // this.router && this.router.navigate("/step/complete");
      })
      .catch(err => {
        console.log("error finalize online catch", err)
        if (!err) return;
        const msg = err.message;
        if (msg.indexOf("insufficient stock quantity") == 0) {
          return this.$f7.dialog.confirm(
            "تغییری در قیمت و یا موجودی کالاهای شما به وجود آمده، لطفا سبدخرید خود را بازنگری کنید.",
            "خطا",
            () => {
              this.router.navigate("/cart", {
                reloadAll: true,
                props: { reloadCart: true }
              });
            }
          );
        } else {
          return this.$f7.dialog.alert(
            "خطایی در ثبت سفاش شما رخ داده، مجددا تلاش کنید.",
            "خطا"
          );
        }
      })
      .finally(r => {
        this.$f7.dialog.close();
      });
  }

  renderFinalize() {
    const { order, user, price } = this.props;

    // console.log("ooooZZZZZ",order);
    return (
      <React.Fragment>
        <GroupBox title={"اطلاعات گیرنده"} outline>
          <CardContent>
            <List>
              <ListItem
                header={"تحویل گیرنده"}
                title={user ? user.firstName + " " + user.lastName : ""}
              />
              <ListItem header={"شماره تماس"} title={user ? user.mobile : ""} />
              <ListItem
                header={"عنوان مقصد"}
                title={
                  order ? order.shippingInfo ? order.shippingInfo.address ? order.shippingInfo.address.title : "" : "" : ""
                }
              />
              <ListItem
                header={"آدرس مقصد"}
                title={
                  order
                    ? order.shippingInfo
                      ? order.shippingInfo.address
                        ? order.shippingInfo.address.text
                        : ""
                      : ""
                    : ""
                }
                link="#"
                popoverOpen=".popover-address"
              />
              <ListItem
                header={"نحوه پرداخت"}
                title={
                  order
                    ? order.billingInfo
                      ? order.billingInfo.method
                        ? order.billingInfo.method.title
                        : ""
                      : ""
                    : ""
                }
              />
            </List>
          </CardContent>
        </GroupBox>

        <CartProduct items={order ? order.cart : []} readOnly={true} />

        <GroupBox title={"توضیحات"} outline>
          <CardContent>
            <List>
              <ListInput
                type="textarea"
                value={this.state.orderDescription}
                placeholder="توضیحات سفارش خود را اینجا بنویسید"
                clearButton
                // required
                validate
                // info={'اجباری، آدرس تحویل گیرنده'}
                errorMessage={"لطفا آدرس تحویل گیرنده را وارد کنید"}
                onChange={this.handleOrderDescription}
                onInputClear={() => this.setState({ orderDescription: '' })}
              // className={classes.input}
              >
              </ListInput>
            </List>
          </CardContent>
        </GroupBox>

        <Description
          delivery={order && order.shippingInfo && order.shippingInfo.price}
          sumBefore={price && price.sumBefore}
          sumOfDiscounts={price && price.sumOfDiscounts}
          sumAfter={price && price.sumAfter}
          gift={order && order.giftId && order.gift && order.gift.value}
        />

        <Popover className="popover-address">
          <Block>
            <p>
              {order
                ? order.shippingInfo
                  ? order.shippingInfo.address
                    ? order.shippingInfo.address.text
                    : ""
                  : ""
                : ""}
            </p>
          </Block>
        </Popover>
      </React.Fragment>
    );
  }

  checkPaymentStatus(orderId, params) {
    setTimeout(handlePaymentCheking, 15000, orderId, params);
    setTimeout(() => {

    }, 1000)

    const handlePaymentCheking = (id, parameters) => {
      this.props.checkPaymentResult(id, parameters)
        .then(res => {
          const { status, state } = res.paymentResult;

          // let refference = {
          //   completed: {
          //     status: 4,
          //     message: "",
          //   },
          //   failed: {
          //     status: 3,
          //     message: "",
          //   },
          //   inProccess: {
          //     status: 2,
          //     message: "",
          //   },
          //   pending: {
          //     status: 1,
          //     message: "",
          //   },
          //   none: {
          //     status: 0,
          //     message: "",
          //   }
          // }
          // const refference = []


          if (status == 4 || status == 3) {

          } else {

          }
        })
        .catch(err => {
          console.log("error check Payment Statuse catch", err)
          if (!err) return;
          const msg = err.message;
          console.log(err.message)

        });

    }

  }

  render() {
    // console.log("render  state online", this.state.isOnlinePayment);

    return (
      <div className={classes.container}>
        <StepsTab step={3} />

        <div className={classes.pagePadding}>{this.renderFinalize()}</div>

        {this.state.isOnlinePayment ?
          <Button
            large
            fill
            icon="mdi-arrow-left"
            text={"تایید نهایی و پرداخت"}
            className={classes.nextButton}
            onClick={() => this.handleNextOnlinePayment()}
          />
          :
          <Button
            large
            fill
            icon="mdi-arrow-left"
            text={"ثبت نهایی"}
            className={classes.nextButton}
            onClick={() => this.handleNext()} />

        }

      </div>
    );
  }
}

export default connect(
  state => ({
    order: state.Order.order,
    gateway: state.Order.gateway,
    paymentResult: state.Order.paymentResult,
    price: state.Order.price,
    user: state.General.user
  }),
  {
    finalize,
    finalizeOnline,
    checkPaymentResult
  }
)(autobind(Finalize));
